import { IBaseParams } from '@interfaces/IBaseParam';
import { callAPIContent } from '@utils/fetcher/content';
import { IParamTahunAjaran } from './tahunajaran.types';

export const getListTahunAjaranFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'academicyear',
    params,
  };
  return callAPIContent(options);
};

export const getDetailTahunAjaranFromAPI = (id: number) => {
  const options = {
    method: 'GET',
    servicePath: 'academicyear',
    params: { id },
  };
  return callAPIContent(options);
};

export const postTahunAjaranFromAPI = (params: IParamTahunAjaran) => {
  const options = {
    method: 'POST',
    servicePath: 'academicyear',
    params,
  };
  return callAPIContent(options);
};

export const deleteTahunAjaranFromAPI = (id: number) => {
  const options = {
    method: 'DELETE',
    servicePath: `academicyear/${id}`,
  };
  return callAPIContent(options);
};

export const updateTahunAjaranFromAPI = (
  id: number,
  params: IParamTahunAjaran,
) => {
  const options = {
    method: 'PUT',
    servicePath: `academicyear/${id}`,
    params,
  };
  return callAPIContent(options);
};

export const setDefaultTahunAjaranFromAPI = (id: number) => {
  const options = {
    method: 'PUT',
    servicePath: `academicyear`,
    uri: `activate/${id}`,
  };
  return callAPIContent(options);
};

export const setDefaultSemesterFromAPI = (id: number) => {
  const options = {
    method: 'PUT',
    servicePath: `academicyear`,
    uri: `semester/activate/${id}`,
  };
  return callAPIContent(options);
};

export const getListSemesterFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'semester',
    params,
  };
  return callAPIContent(options);
};

export const getAcademicActiveFromAPI = () => {
  const options = {
    method: 'GET',
    servicePath: 'academicyear/active',
  };
  return callAPIContent(options);
};

export const getSemesterActiveFromAPI = () => {
  const options = {
    method: 'GET',
    servicePath: 'academicyear',
    uri: 'semester/active',
  };
  return callAPIContent(options);
};
